<template>
  <el-dialog title="查看" :visible.sync="dialogVisible" width="40%">
    <span>
      <video v-if="Item.mtma04 == '1'" :src="$store.state.baseUrl + Item.mtma05" id="videoPath" ref="audio"
        poster="../../../assets/img/ycy-cy-3.png" autoplay loop muted controls="fasle"
        style="width: 100%; height: 100%; object-fit: unset"></video>
      <img v-else-if="Item.mtma04 == '2'" :src="$store.state.baseUrl + Item.mtma05" style="width: 100%; height: 100%"
        alt />
      <BimModel v-else style="width: 100%; height: 100%; position: relative" :url="[Item]"></BimModel>
    </span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import BimModel from "../../Wisdom/bimViewModelIfram";
export default {
  name: "RunhongLookOver",
  data() {
    return {
      dialogVisible: false,
      Item: {},
      menuList: [
        {
          name: "智能装备概况",
          is: true,
          type: "mp4",
          videoPath: "./video/项目之窗.mp4",
        },
        {
          name: "智能装备定位",
          type: "model",
          is: false,
          videoPath: "./video/项目之窗.mp4",
        },
        {
          name: "数字化建造监控",
          type: "model",
          is: false,
          videoPath: "./video/项目之窗.mp4",
        },
        {
          name: "数字建造模拟",
          type: "model",
          is: false,
          videoPath: "./video/项目之窗.mp4",
        },
      ],
    };
  },
  components: { BimModel },

  mounted() { },

  methods: {
    Open(data) {
      this.Item = data;
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dialog__body,
.home {
  min-height: 500px;
}
</style>
